// import { getAllServerType, saveNewServerType } from "../../store/actions/servertype";

export const SERVER_TYPES = [
  { key: "WINDOW", value: "Windows" },
  { key: "LINUX", value: "Linux" },
];

export const DATA_CENTER_LOCATION = [
  { key: "USA", value: "USA" },
];

export const REMOTE_TYPES = {
  Windows: [
    { key: "RDP", value: "RDPs" },
  ],
  Linux: [{ key: "PUTTY", value: "PUTTY" },{ key: "WINSCP", value: "WINSCP" }],
};

export const PANEL_TYPES = {
  Windows: [
    { key: "PLESK", value: "Plesk" },
    { key: "SOLIDCP", value: "SolidCP" },
  ],
  Linux: [
    { key: "PLESK", value: "Plesk" },
    { key: "WEBUZO", value: "Webuzo" },
  ],
};

// // Messages
// export const MESSAGES = {
//   LOADING: 'Loading...',
//   NO_DATA: 'No data found',
//   ERROR: 'An error occurred'
// };

// // Table Settings
// export const TABLE_SETTINGS = {
//   DEFAULT_PAGE_SIZE: 10,
//   PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
// };


export const MESSAGES = {
  LOADING: "Loading...",
  NO_DATA: "No data found",
  ERROR: "An error occurred",
};

// Table Settings
export const TABLE_SETTINGS = {
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100],
};

/**
 * Fetch Server Types from API
 */
// export const fetchServerTypes = async () => {
//   try {
//     const response = await fetch("https://your-api-endpoint.com/server-types"); // Replace with actual API URL
//     const data = await response.json();

//     if (data.success && data.result.success) {
//       return data.result.result.map((item) => ({
//         key: item._id,
//         value: item.name,
//       }));
//     }
//     return [];
//   } catch (error) {
//     console.error("Error fetching Server Types:", error);
//     return [];
//   }
// };

// /**
//  * Fetch Data Center Locations from API
//  */
// export const fetchDataCenterLocations = async () => {
//   try {
//     const response = await fetch("https://your-api-endpoint.com/data-centers"); // Replace with actual API URL
//     const data = await response.json();

//     if (data.success && data.result.success) {
//       return data.result.result.map((item) => ({
//         key: item._id,
//         value: item.name,
//       }));
//     }
//     return [];
//   } catch (error) {
//     console.error("Error fetching Data Center Locations:", error);
//     return [];
//   }
// };

// /**
//  * Fetch Remote Types from API
//  */
// export const fetchRemoteTypes = async (serverType) => {
//   try {
//     const response = await fetch(
//       `https://your-api-endpoint.com/remote-types?serverType=${serverType}`
//     ); // Replace with actual API URL
//     const data = await response.json();

//     if (data.success && data.result.success) {
//       return data.result.result.map((item) => ({
//         key: item._id,
//         value: item.name,
//       }));
//     }
//     return [];
//   } catch (error) {
//     console.error("Error fetching Remote Types:", error);
//     return [];
//   }
// };

// /**
//  * Fetch Panel Types from API
//  */
// export const fetchPanelTypes = async (serverType) => {
//   try {
//     const response = await fetch(
//       `https://your-api-endpoint.com/panel-types?serverType=${serverType}`
//     ); // Replace with actual API URL
//     const data = await response.json();

//     if (data.success && data.result.success) {
//       return data.result.result.map((item) => ({
//         key: item._id,
//         value: item.name,
//       }));
//     }
//     return [];
//   } catch (error) {
//     console.error("Error fetching Panel Types:", error);
//     return [];
//   }
// };
